const $$splitComponentImporter = () => import('/app/src/routes/dashboard/admin/settings.tsr-split.component.tsx');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { parseAdminSettingsSearch } from "@/components/admin/settings/types";
export const Route = createFileRoute("/dashboard/admin/settings")({
  validateSearch: (search: Record<string, unknown>) => parseAdminSettingsSearch(search),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});